import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useLanguage } from '../../../../../../contexts/LanguageContext';
import { useGetAvailableWarrantyTypesQuery } from '../../../../../../api/endpoints/warrantyClaims';
import { formatDateForApi } from '../../../../../../utils/dateUtils';

const WarrantyTypeDropdown = ({ value, onChange, className, chassisNo, claimDate, kmInformation }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const [selectedWarrantyType, setWarrantyType] = useState(null);

    const shouldFetchData = Boolean(chassisNo && claimDate && kmInformation !== undefined);

    const { data: warrantyTypesData, isLoading: isLoadingType } = useGetAvailableWarrantyTypesQuery(
        {
            ChassisNo: chassisNo,
            ClaimDate: formatDateForApi(claimDate),
            KmInformation: kmInformation,
            LanguageId: getCurrentLanguageId()
        },
        {
            skip: !shouldFetchData
        }
    );

    const warrantyTypeList = warrantyTypesData?.warrantyTypes || [];

    const warrantyTypeOptions = warrantyTypeList.map((type) => ({
        id: type.id,
        code: type.code,
        text: type.translatedText,
        displayValue: type.translatedText
    }));

    const handleSelectionChange = (e) => {
        setWarrantyType(e.value);
        onChange(e.value ? e.value.code : '', e.value);
    };

    useEffect(() => {
        if (selectedWarrantyType) {
            if (typeof value === 'string' && selectedWarrantyType.id === value) {
                return;
            } else if (typeof value === 'object' && value !== null && selectedWarrantyType.id === value.id) {
                return;
            }
        }

        if (warrantyTypeOptions.length > 0 && value) {
            let found;

            if (typeof value === 'string') {
                found = warrantyTypeOptions.find((option) => option.id === value || option.code === value || option.displayValue === value || option.text === value);
            } else if (typeof value === 'object' && value !== null) {
                found = warrantyTypeOptions.find((option) => option.id === value.id || option.code === value.code || option.displayValue === value.displayValue);
            }

            if (found) {
                setWarrantyType(found);
            } else if (typeof value === 'object' && value !== null) {
                const newOption = {
                    id: value.id || value.chassisNo || '',
                    text: value.text || value.translatedText || value.id || value.chassisNo || '',
                    displayValue: value.displayValue || `${value.id || value.chassisNo || ''} - ${value.text || value.translatedText || ''}`
                };
                setWarrantyType(newOption);
            }
        }
    }, [value, warrantyTypeOptions.length]);

    return (
        <Dropdown
            value={selectedWarrantyType}
            options={warrantyTypeOptions}
            onChange={handleSelectionChange}
            optionLabel="displayValue"
            showClear
            className={className}
            placeholder={th('warrantyClaims.component.warrantyTypePlaceholder')}
            loading={isLoadingType}
            itemTemplate={(option) => <div>{option.text}</div>}
        />
    );
};
export default WarrantyTypeDropdown;
